import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import { formatHeat } from "@/utils/movie";

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block animate-fade-in cursor-pointer"
      title={`${movie.title} - 蓝莓视频`}
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 封面`}
          title={`${movie.title} - 蓝莓视频高清影视资源`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent opacity-80"></div>

        <span className="absolute top-2 right-2 flex items-center gap-1 bg-accent-500/95 text-background-50 text-xs font-semibold px-2 py-0.5 rounded-md">
          <i className="ri-star-fill text-[10px]"></i>
          {movie.rating.toFixed(1)}
        </span>

        {typeof rank === "number" && (
          <span className="absolute top-0 left-0 w-8 h-8 flex items-center justify-center rounded-br-lg bg-primary-500 text-foreground-950 font-heading font-bold text-sm">
            {rank}
          </span>
        )}

        <span className="absolute bottom-2 left-2 flex items-center gap-1 text-[11px] text-foreground-900 bg-background-50/70 px-2 py-0.5 rounded-md">
          <i className="ri-fire-line text-accent-400"></i>
          {formatHeat(movie.heat)}
        </span>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500/90 text-background-50">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </div>
      </div>

      <div className="mt-3">
        <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-accent-500 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {movie.type === "movie" ? "电影" : "电视剧"} · {movie.region} · {movie.year}
        </p>
      </div>
    </Link>
  );
}